import { FaRegClock } from 'react-icons/fa';
import { FieldShell } from './FieldShell';
import { useDomFieldId } from './_useFieldName';
import { FIELD_AUTOCOMPLETE_OFF } from './_fieldDefaults';

const BLOCK = 'LStudio__app_field';

/*
    🔥 HORA

    input[type=time] nativo. El reloj lo dibuja el sistema, así que
    su color lo decide color-scheme (ver GLOBAL/_ColorScheme.css).
    Por eso no necesita librería.
*/

export const FieldTime = ({
    id, name, label, hint, error,
    value, onChange, min = null, max = null, step = 60,
    isRequired = false, isDisabled = false,
    span = 1, ...rest
}) => {

    const DOM_ID = useDomFieldId(id);

    return (

    <FieldShell id={DOM_ID} label={label} hint={hint} error={error}
        isRequired={isRequired} isDisabled={isDisabled} span={span} >

        <div className={`${BLOCK}__wrap`}>

            <input id={DOM_ID} data-field={name ?? id} name={name ?? id} type="time"
                className={`${BLOCK}__input`}
                value={value ?? ''} onChange={onChange}
                min={min ?? undefined} max={max ?? undefined} step={step}
                required={isRequired} disabled={isDisabled}
                autoComplete={FIELD_AUTOCOMPLETE_OFF}
                aria-invalid={!!error}
                data-has-end={true}
                {...rest} />

            <span className={`${BLOCK}__icon ${BLOCK}__icon--end`} aria-hidden="true">
                <FaRegClock />
            </span>

        </div>

    </FieldShell>
);
};
